import { fmtDate, fmtTime } from '../../lib/format';
import { AREA_LABEL, type StaffArea, type Ustva } from '../../types';
import type { Consent } from './types';

// Texte rund um Mandanten und Team (wie in der Demo).

export const USTVA_OPTS: [Ustva, string][] = [
  ['M', 'Monatlich'],
  ['Q', 'Quartalsweise'],
  ['J', 'Jährlich'],
  ['B', 'Befreit'],
];

export const USTVA_LIST: Record<Ustva, string> = {
  M: 'UStVA monatlich',
  Q: 'UStVA quartalsweise',
  J: 'nur Jahreserklärung',
  B: 'befreit',
};

export const USTVA_NOTE: Record<Ustva, string> = {
  M: 'UStVA jeden Monat bis zum 10.',
  Q: 'UStVA pro Quartal bis zum 10. nach Quartalsende.',
  J: 'Keine UStVA im Jahr, nur die USt-Jahreserklärung.',
  B: 'Von der Umsatzsteuer befreit (z. B. Kleinunternehmer). Keine UStVA.',
};

export const ustvaLabel = (u: Ustva) => USTVA_OPTS.find((o) => o[0] === u)?.[1] ?? u;

// „Lena Brandt (Finanzbuchhaltung)“
export const staffLabel = (s: { name: string; area: StaffArea | null }) => `${s.name} (${AREA_LABEL[s.area ?? 'fibu']})`;

// Zuständig nur passend zum Bereich (der Server prüft das auch): Lohn nur Lohn oder beides, FiBu nur FiBu oder beides
export const fitsArea = (s: { area: StaffArea | null }, area: 'fibu' | 'lohn') => s.area === area || s.area === 'beides';

// „Ringstraße 7, 04109 Leipzig“
export function addressLine(c: { street: string; zip: string; city: string }): string {
  return [c.street, [c.zip, c.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
}

// Bereich eines Mitarbeiters bei einem Mandanten: „FiBu“, „Lohn“ oder „FiBu und Lohn“
export function myAreas(c: { fibu: { id: string } | null; lohn: { id: string } | null }, userId: string): string {
  const a: string[] = [];
  if (c.fibu?.id === userId) a.push('FiBu');
  if (c.lohn?.id === userId) a.push('Lohn');
  return a.join(' und ');
}

export const AREAS = [
  { key: 'fibu', label: 'Finanzbuchhaltung', short: 'FiBu' },
  { key: 'lohn', label: 'Lohn & Gehalt', short: 'Lohn' },
] as const;

// Nachweis der Häkchen bei der Registrierung (AGB und AV-Vertrag nach Art. 28 DSGVO)
export function consentText(c: Consent): string {
  const stand = (v: string | null) => (v ? ` (Stand ${v})` : '');
  if (!c.avAt) return `AGB am ${fmtDate(c.agbAt)} akzeptiert. Kein AV-Vertrag in der App (Registrierung vor Oktober 2026).`;
  const firm = c.unternehmerAt ? ' Als Unternehmen angemeldet.' : '';
  return `AGB${stand(c.agbVersion)} und AV-Vertrag${stand(c.avVersion)} am ${fmtDate(c.avAt)}, ${fmtTime(c.avAt)} Uhr akzeptiert.${firm}`;
}
